import { render } from "./CreateResultForm.vue?vue&type=template&id=536f049a&scoped=true&ts=true"
import script from "./CreateResultForm.vue?vue&type=script&lang=ts"
export * from "./CreateResultForm.vue?vue&type=script&lang=ts"

import "./CreateResultForm.vue?vue&type=style&index=0&id=536f049a&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536f049a"]])

export default __exports__